import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Share2 } from "lucide-react";
import { api, errText } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { SOCIAL_NETWORKS } from "../../components/SocialIcons";

export function SocialLinksSettings() {
  const [links, setLinks] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/site/social").then((r) => setLinks(r.data)).catch(() => setLinks({})); }, []);
  const save = async () => {
    setSaving(true);
    try { const { data } = await api.put("/admin/site/social", links); setLinks(data); toast.success("Social links saved — they now show in emails and the site footer"); }
    catch (e) { toast.error(errText(e)); }
    finally { setSaving(false); }
  };
  if (!links) return null;
  return (
    <div className="bg-white rounded-2xl border border-slate-200/80 p-6 mt-6" data-testid="social-links-settings">
      <div className="flex items-center gap-2">
        <Share2 size={17} className="text-[#F5551E]" />
        <h3 className="font-display font-bold text-[#12234A]">Social links</h3>
      </div>
      <p className="text-xs text-slate-500 mt-1 mb-4">Shown as icons in the website footer and as buttons in the footer of every email. Leave blank to hide a network.</p>
      <div className="grid sm:grid-cols-2 gap-3">
        {SOCIAL_NETWORKS.map(({ id, label, Icon, placeholder }) => (
          <label key={id} className="flex items-center gap-2">
            <span className="h-9 w-9 shrink-0 rounded-lg bg-[#12234A] text-white flex items-center justify-center"><Icon size={16} /></span>
            <Input value={links[id] || ""} onChange={(e) => setLinks({ ...links, [id]: e.target.value })} placeholder={placeholder} aria-label={label}
              className="h-9 rounded-lg" data-testid={`social-input-${id}`} />
          </label>
        ))}
      </div>
      <Button onClick={save} disabled={saving} className="mt-4 rounded-xl bg-[#F5551E] hover:bg-[#E04812] text-white font-semibold" data-testid="social-save-btn">
        {saving ? "Saving…" : "Save social links"}
      </Button>
    </div>
  );
}
